import {
  PRE_SALES_LISTING,
  VIEW_CONTRACT,
  STATUS_LIST,
  DEAL_STATUS_LIST,
  UPDATE_LEAD_STATUS,
  VIEW_DETAILS,
  FILTER_DROPDOWN_LIST,
  FETCH_ZONES_LIST,
  VIEW_SITE_DETAILS,
  RETURN_TAG,
  MAP_INFRA_PROJECT,
  PROJECT_MAPPING_DETAILS
} from "./type";

const initalState = {
  perSalesList: {},
  statusList: [],
  dealStatusList: [],
  viewDetails: {},
  viewContract: {},
  filterDropdownList: {},
  getFetchZones: {},
  viewSiteDetails: [],
  returnTagDetails:[],
  mappedInfraProject:[],
  projectMappingDetails:[]
};

const preSalesListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRE_SALES_LISTING:
      return {
        ...state,
        perSalesList: payload,
      };

    case STATUS_LIST:
      return {
        ...state,
        statusList: payload,
      };

      case DEAL_STATUS_LIST:
      return {
        ...state,
        dealStatusList: payload,
      };

    case UPDATE_LEAD_STATUS:
      return {
        ...state,
        followUpList: payload,
      };

    case FILTER_DROPDOWN_LIST:
      return {
        ...state,
        filterDropdownList: payload,
      };

    case FETCH_ZONES_LIST:
      return {
        ...state,
        getFetchZones: payload,
      };

      case VIEW_DETAILS:
        return {
          ...state,
          viewDetails: payload
        }
      case VIEW_CONTRACT:
      return {
        ...state,
        viewContract: payload
      }
      case VIEW_SITE_DETAILS:
      return {
        ...state,
        viewSiteDetails: payload
      }
    case RETURN_TAG:
      return {
        ...state,
        returnTagDetails: payload
      }
    case MAP_INFRA_PROJECT:
      return {
        ...state,
        mappedInfraProject: payload
      }
    case PROJECT_MAPPING_DETAILS:
      return {
        ...state,
        projectMappingDetails: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default preSalesListReducer;
